import { render } from "./BottomNavigationItem.vue?vue&type=template&id=cebbd5aa"
import script from "./BottomNavigationItem.vue?vue&type=script&lang=js"
export * from "./BottomNavigationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/BottomNavigationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cebbd5aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cebbd5aa', __exports__)) {
    api.reload('cebbd5aa', __exports__)
  }
  
  module.hot.accept("./BottomNavigationItem.vue?vue&type=template&id=cebbd5aa", () => {
    api.rerender('cebbd5aa', render)
  })

}


export default __exports__